
import { useCallback, useMemo } from 'react';
import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { JsonServiceClient } from '@servicestack/client';
import { Authenticate, AuthenticateResponse, ResponseStatus } from '@/api/dtos';
import DefaultClient from '@/api/DefaultClient';

const url = `/api/authenticate`;

const fetcher = async () => {
    const client = DefaultClient(import.meta.env.VITE_API_URL, "/api");
    return await client.get(new Authenticate());
}

export const useAuthenticatedUser = (configuration: SWRConfiguration) => {
    const response = useSWR<AuthenticateResponse, AuthenticateResponse>(url, fetcher, configuration);

    const result = useMemo(() => {
        const d = response.data;
        const e = (response.error as any)?.responseStatus as ResponseStatus | undefined;

        const s = {
            data: d,
            error: e,
            loading: response.isValidating && !d && !e,
            validating: response.isValidating,
            mutate: response.mutate,
            refresh: async () => {
                const newResponse = await response.mutate(response.data, { revalidate: true })

                return newResponse;
            }
        }

        return s;

    }, [response]);

    return result;
};